import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import DeleteModal from "../../component/Modal/Delete";
import Accepted from "../../component/Modal/Accepted";
import { useToggle } from "./../../utils/hooks/index";
import { variants } from "../../constant/Variants";
import { SchoolDeleteReducer, SchoolListReducer, SchoolActiveInactiveReducer } from "../slice";
import { toast } from "react-toastify";
import Paginations from "../../component/Pagination";
import { areaCodeListingSelector, FetchAreaCodeList } from "../areacode/slice";
import Select from "react-select";
import { getTeacherId } from "../../app/globalStore";

function SchoolList() {
  const dispatch = useDispatch();
  const teacher_id = getTeacherId();
  const list = useSelector((state) => state.main.schools);
  const total = useSelector((state) => state.main.total_school);
  const areaList = useSelector(areaCodeListingSelector);
  
  // Restore pagination state from sessionStorage on component mount
  const [search, setSearch] = useState(() => {
    return sessionStorage.getItem('schoolListSearch') || "";
  });
  const [delId, setDelId] = useState("");
  const [show, toggle] = useToggle();
  const [modalName, setModalName] = useState("");
  const [confirmStatus, setconfirmStatus] = useState("");
  const [actionName, setActionName] = useState("");
  const [activePage, setActivePage] = useState(1);
  // Restore active/inactive tab state from sessionStorage on component mount
  const [activeVenue, setActiveVenue] = useState(() => {
    const savedVenue = sessionStorage.getItem('schoolListActiveVenue');
    return savedVenue ? parseInt(savedVenue) : 1;
  });
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem('schoolListPage');
    return savedPage ? parseInt(savedPage) : 1;
  });
  // Restore region filter state from sessionStorage on component mount
  const [areacode, setAreacode] = useState(() => {
    return sessionStorage.getItem('schoolListAreacode') || "";
  });
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  // Restore company selection state from sessionStorage on component mount
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const savedCompany = sessionStorage.getItem('schoolListCompany');
    return savedCompany ? parseInt(savedCompany) : 0;
  });
  const handlePage = (value) => {
    setPage(value);
  };

  const getList = useCallback(() => {
    dispatch(
      SchoolListReducer({
        page: page,
        limit: 10,
        status: activeVenue,
        search: search,
        areacode,
        company_id:selectedCompany
      })
    );
  }, [dispatch, page, search, areacode, activeVenue, selectedCompany]);

  const confirmDelete = (data) => {
    dispatch(SchoolDeleteReducer({ school_id: delId })).then((res) => {
      if (res?.payload?.code === 1) {
        toast.success(res?.payload?.message, {  autoClose: false,  closeButton: true});
        getList();
      } else {
        toast?.error(res?.payload?.message);
      }
    });
  };

  const handleModal = (val) => {
    setModalName(val);
    toggle();
  };

  const approvedReject = (data) => {
    dispatch(
      SchoolActiveInactiveReducer({ school_id: delId, status: confirmStatus })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        toast.success(res?.payload?.message, {  autoClose: false, closeButton: true});
        getList();
      } else {
        toast?.error(res?.payload?.message);
      }
    });
  };

  useEffect(() => {
    let isRendered = false;

    if (!isRendered) {
      getList();
    };
    return () => {
      isRendered = true;
    };
  }, [getList]);

  useEffect(() => {
    sessionStorage.setItem('schoolListPage', page.toString());
  }, [page]);

  useEffect(() => {
    sessionStorage.setItem('schoolListSearch', search);
  }, [search]);

  // Save active/inactive tab state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('schoolListActiveVenue', activeVenue.toString());
  }, [activeVenue]);

  // Save region filter state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('schoolListAreacode', areacode);
  }, [areacode]);

  // Save company selection state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('schoolListCompany', selectedCompany.toString());
  }, [selectedCompany]);

  useEffect(() => {
    dispatch(FetchAreaCodeList({ page: 1, limit: 10000, company_id:selectedCompany }));
  }, [dispatch, selectedCompany]);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/users-selected.png" alt="" /> Total
                Locations {total}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search Location by Name"
                  value={search}
                  onChange={(e) => {
                    setPage(1);

                    setSearch(e.target.value);
                  }}
                />
              </form>
              <Link to="/add-school" className="">
                <img
                  src="assets/images/addBtn.png"
                  alt=""
                  className="add-new"
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="row mt-3">
        <div className="col-sm-12 col-md-12 col-lg-9">
              <ul
                className="nav nav-pills group-nav mb-3 mt-0"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeVenue === 1 ? "active" : ""}`}
                    id="pills-new-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-new"
                    type="button"
                    role="tab"
                    aria-controls="pills-new"
                    aria-selected={activeVenue === 1}
                    onClick={() => {
                      setPage(1)
                      setActiveVenue(1)
                      getList()
                    }}
                  >
                    Active
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeVenue === 0 ? "active" : ""}`}
                    id="pills-new-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-new"
                    type="button"
                    role="tab"
                    aria-controls="pills-new"
                    aria-selected={activeVenue === 0}
                    onClick={() => {
                      setPage(1)
                      setActiveVenue(0)
                      getList()
                    }}
                  >
                    Inactive
                  </button>
                </li>
              </ul>
            </div>
          <div className="col-sm-12 col-md-12 col-lg-3 float-right">
            <div className="form-group selectAreaCode">
              <div className="input-container">
                <select
                  className="form-control pl-5 form-select"
                  name="areacode"
                  value={areacode}
                  onChange={(e) => {
                    setAreacode(e.target.value);
                  }}
                >
                  <option value="">Select Region</option>
                  {Array.isArray(areaList) && areaList?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.areacode}
                    </option>
                  ))}
                </select>
                <img
                  src="assets/images/event-name.png"
                  className="input-img"
                  alt=""
                />
              </div>
            </div>
          </div>
          {Array.isArray(companyOptions) && companyOptions.length > 0 && (
          <div className="col-sm-12 col-md-12 col-lg-4 mb-3">
            <Select
                options={companyOptions}
                isSearchable
                placeholder="Select a company..."
                value={companyOptions.find(option => option.value === selectedCompany)}
                onChange={option => {
                  setSelectedCompany(option.value);
                }}
              />
            </div>
          )}
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Location name</th>
                    <th scope="col">Region</th>
                    <th scope="col">Address</th>
                    <th scope="col">Hall Fees(per hour)</th>
                    <th scope="col">Hall Fees(per day)</th>
                    <th scope="col">Status</th>
                    <th scope="col">action</th> 
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {list?.length > 0 ? (
                    list?.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item?.id}</td>
                          {/* <td>
                            <span>
                              <img
                                src={
                                  item?.image?.includes("http")
                                    ? item?.image
                                    : "assets/images/employe.png"
                                }
                                className="table-img"
                                alt="school"
                              />{" "}
                            </span>
                          </td> */}
                          <td>{item?.name}</td>
                          <td>{item?.areacode_details?.areacode || "NA"}</td>
                          <td>{item?.address}</td>
                          <td>£{item?.hall_fees_per_hour}</td>
                          <td>£{item?.hall_fees_per_day}</td>
                          <td>
                            <button
                              type="button"
                              className="btn"
                              onClick={() => {
                                const newStatus = item?.isActive == 1 ? 0 : 1;
                                handleModal("Confirmation");
                                setDelId(item?.id);
                                setconfirmStatus(newStatus);
                                setActionName(newStatus == 1 ? "Active" : "Inactive");
                              }}
                              title={item?.isActive == 1 ? "Click to Deactivate" : "Click to Activate"}
                              style={{
                                color: item?.isActive == 1 ? "#28a745" : "#c20824",
                                fontWeight: "500",
                                padding: "5px 10px",
                                borderRadius: "4px",
                                backgroundColor: item?.isActive == 1 ? "rgba(40, 167, 69, 0.1)" : "rgba(194, 8, 36, 0.1)",
                                border: "none",
                                cursor: "pointer"
                              }}
                            >
                              {item?.isActive == 1 ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center action">
                              <button className="btn" title="View">
                                <Link to={`/view-school/${item?.id}`}>
                                  <img src="assets/images/view.png" alt="" />
                                </Link>
                              </button>
                              <button className="btn" title="Edit">
                                <Link to={`/edit-school/${item?.id}`}>
                                  <img src="assets/images/edit.png" alt="" />
                                </Link>
                              </button>
                              {teacher_id === 0 && (
                              <button
                                className="btn"
                                onClick={() => {
                                  toggle();
                                  setDelId(item?.id);
                                }}
                                title="Delete"
                              >
                                <img src="assets/images/delete.png" alt="" />
                              </button>
                              )}
                              {/* <button className="btn">
                                <input
                                  type="checkbox"
                                  className="toggle"
                                  checked=""
                                />
                              </button> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>No data found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {list?.length > 0 && (
            <Paginations
              handlePage={handlePage}
              page={page}
              total={total && total}
            />
          )}
        </div>
      </div>
      <DeleteModal
        page="Location"
        show={show}
        handleShow={toggle}
        confirmDelete={confirmDelete}
      />
      {modalName === "Confirmation" && delId && (
        <Accepted
          show={show}
          handleShow={toggle}
          pageName="Location"
          actionName={actionName}
          approvedReject={approvedReject}
          delId={delId}
          getList={getList}
        />
      )}
    </article>
  );
}

export default SchoolList;
